export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13167.72a7d73a.jpg";